import { render, staticRenderFns } from "./WaveView.vue?vue&type=template&id=e8b63d62&scoped=true&"
import script from "./WaveView.vue?vue&type=script&lang=js&"
export * from "./WaveView.vue?vue&type=script&lang=js&"
import style0 from "./WaveView.vue?vue&type=style&index=0&id=e8b63d62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b63d62",
  null
  
)

export default component.exports